module.exports = __webpack_public_path__ + "static/media/messageWallOff_v2_withTele.c2b12afd.png";